<!-- ===== Header ===== -->
<div class="card shadow-sm border-0 mb-3">
  <div class="card-body py-3">
    <h4 class="card-title mb-0 fw-semibold">
      {{ 'MENU.DASHBOARD.NOTIFICATIONSs.ADD' | translate }}
    </h4>
  </div>

<!-- ===== Form Card ===== -->
<div class="card shadow-sm border-0">
  <div class="card-body">

    <form (ngSubmit)="onSubmit()" enctype="multipart/form-data">

      <div class="row justify-content-center">
        <div class="col-lg-8">

          <!-- User -->
          <div class="mb-3">
            <label class="form-label fw-medium">
              {{ 'MENU.DASHBOARD.User_ID' | translate }}
            </label>

            <select
              class="form-control"
              [(ngModel)]="formData.user_id"
              name="user_id"
              required
            >
              <option [ngValue]="null" disabled selected>
                {{ 'MENU.DASHBOARD.Select_User' | translate }}
              </option>
              <option *ngFor="let user of arrCoupons" [ngValue]="user.id">
                {{ user.name }}
              </option>
            </select>

            <small class="text-danger" *ngIf="errors?.user_id">
              {{ errors.user_id[0] }}
            </small>
          </div>

          <!-- Title -->
          <div class="mb-3">
            <label class="form-label fw-medium">
              {{ 'MENU.DASHBOARD.Title' | translate }}
            </label>

            <input
              type="text"
              class="form-control"
              placeholder="{{ 'MENU.DASHBOARD.Title' | translate }}"
              [(ngModel)]="formData.title"
              name="title"
              required
            />

            <small class="text-danger" *ngIf="errors?.title">
              {{ errors.title[0] }}
            </small>
          </div>

          <!-- Message -->
          <div class="mb-4">
            <label class="form-label fw-medium">
              {{ 'MENU.DASHBOARD.Message' | translate }}
            </label>

            <textarea
              class="form-control"
              rows="4"
              placeholder="{{ 'MENU.DASHBOARD.Message' | translate }}"
              [(ngModel)]="formData.message"
              name="message"
              required
            ></textarea>

            <small class="text-danger" *ngIf="errors?.message">
              {{ errors.message[0] }}
            </small>
          </div>

          <!-- Submit -->
          <div class="d-flex justify-content-end">
            <button type="submit" class="btn btn-primary px-4">
              {{ 'MENU.DASHBOARD.Add' | translate }}
            </button>
          </div>

        </div>
      </div>

    </form>

  </div></div>

</div>
